import template from './ratings_distribution.html';
import tr from '../../../lib/default-translator.js';

class ReportRatingsDistributionViewModel
{
	constructor(page)
	{
		this.page = page;
		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.selected_employee = ko.observable();
		this.selected_cycle = ko.observable();
		this.selected_filter_by = ko.observable('employee');
		this.selected_manager = ko.observable();
		this.rating_distribution = ko.observableArray();
		this.selected_method = ko.observable();
		this.show_percentage = ko.observable(false);
		this.performance_cycles = ko.observableArray();
		this.rating_methods = ko.observableArray();
		this.selected_method_name = ko.observable([]);
		this.selected_cycle_name = ko.observable([]);

		this.selected_method_name.subscribe(() => {
			this.page.updateData();
		});

		this.selected_cycle_name.subscribe(() => {
			this.page.updateData();
		});

		this.selected_performance_cycle_text = ko.computed(() => {
			let selected_performance = this.selected_cycle_name();
			if (!Array.isArray(selected_performance)) selected_performance = ko.unwrap(selected_performance);
			if (!selected_performance || selected_performance.length === 0) return 'Filter by performance cycle';
			if (selected_performance.length > 3) return `${selected_performance.length} Performance cycles selected`;
			return selected_performance.join(', ');
		});

		this.selected_method_text = ko.computed(() => {
			let selected_rating_method = this.selected_method_name();
			if (!Array.isArray(selected_rating_method)) selected_rating_method = ko.unwrap(selected_rating_method);
			if (!selected_rating_method || selected_rating_method.length === 0) return 'Filter by rating method';
			if (selected_rating_method.length > 3) return `${selected_rating_method.length} Rating methods selected`;
			return selected_rating_method.join(', ');
		});

		this.show_percentage.subscribe((value) => {
			this.page.updateData();
		}); 

		this.selected_cycle.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_method.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_department.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_company.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_employee.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_manager.subscribe((value) => {
			this.page.updateData();
		});


		this.clear_performance_filter = () => {
			this.selected_cycle_name([]);
			this.page.updateData();
		};

		this.clear_rating_filter = () => {
			this.selected_method_name([]);
			this.page.updateData();
		};
	}

	toggle_selected_performance_selection(cycle_name)
	{
		let cycles = this.selected_cycle_name() || [];
		if (cycles.includes(cycle_name))
			this.selected_cycle_name(cycles.filter(name => name !== cycle_name));
		else
			this.selected_cycle_name([...cycles, cycle_name]);
	}

	toggle_rating_method_selection(name)
	{
		let rating_methods = this.selected_method_name() || [];
		if (rating_methods.includes(name)) 
			this.selected_method_name(rating_methods.filter(method => method !== name));
		else 
			this.selected_method_name([...rating_methods, name]);
	}

	async init_chart()
	{
		await this.update_chart_options();
	}

	async fetch_ratings_distribution_data()
	{
		let selected_cycles = this.selected_cycle_name();
		let selected_cycle_ids = this.performance_cycles().filter(cycle => selected_cycles.includes(cycle.cycle_name)).map(cycle => cycle.performance_cycle_id);

		let filter_options = {
			selected_cycle_ids: selected_cycle_ids,
			selected_methods: this.selected_method_name(),
			employee_id: this.selected_employee()?.employee_id,
			company_id: this.selected_company()?.company_id,
			department_id: this.selected_department()?.department_id,
			manager_id: this.selected_manager()?.employee_id
		};

		try
		{
			let ratings = {
				table: 'v_performance_rating_methods',
				schema: 'perfm_manage',
				limit: 1000000,
				offset: 0,
				filter: []
			};

			if (filter_options.selected_cycle_ids && filter_options.selected_cycle_ids.length > 0)
			{
				ratings.filter.push({
					field: 'performance_cycle_id',
					operator: 'in',
					value: filter_options.selected_cycle_ids
				});
			}

			if (filter_options.selected_methods && filter_options.selected_methods.length > 0)
			{
				ratings.filter.push({
					field: 'rating_method_name',
					operator: 'in',
					value: filter_options.selected_methods
				});
			}

			if (filter_options.department_id)
			{
				ratings.filter.push({
					field: 'department_id',
					operator: '=',
					value: filter_options.department_id
				});
			}

			if (filter_options.company_id)
			{
				ratings.filter.push({
					field: 'company_id',
					operator: '=',
					value: filter_options.company_id
				});
			}

			if (filter_options.manager_id)
			{
				ratings.filter.push({
					field: 'manager_employee_id',
					operator: '=',
					value: filter_options.manager_id
				});
			}

			let employee_count_query;

			if (this.selected_filter_by() === 'employee')
			{
				employee_count_query = {
					table: 'v_active_employees_department',
					schema: 'savanna',
					columns: ['employee_id'],
					limit: 1,
					offset: 0,
					filter: [{
						field: 'employee_id',
						operator: '=',
						value: filter_options.employee_id
					}]
				};
			}
			else if (this.selected_filter_by() === 'manager')
			{
				employee_count_query = {
					table: 'v_performance_rating_methods',
					schema: 'perfm_manage',
					limit: 1000000,
					offset: 0,
					filter: [{
						field: 'manager_employee_id',
						operator: '=',
						value: filter_options.manager_id
					}]
				};

				if (filter_options.selected_cycle_ids && filter_options.selected_cycle_ids.length > 0)
				{
					employee_count_query.filter.push({
						field: 'performance_cycle_id',
						operator: 'in',
						value: filter_options.selected_cycle_ids
					});
				}
			}
			else if (this.selected_filter_by() === 'department')
			{
				employee_count_query = {
					table: 'v_active_employees_department',
					schema: 'savanna',
					limit: 1000000,
					offset: 0,
					filter: [{
						field: 'department_id',
						operator: '=',
						value: filter_options.department_id
					}]
				};
			}
			else if (this.selected_filter_by() === 'company')
			{
				employee_count_query = {
					table: 'v_active_employees_department',
					schema: 'savanna',
					limit: 1000000,
					offset: 0,
					filter: [{
						field: 'company_id',
						operator: '=',
						value: filter_options.company_id
					}]
				};
			}
			else {
				employee_count_query = {
					table: 'v_active_employees_department',
					schema: 'savanna',
					limit: 1000000,
					offset: 0
				};
			}

			let [ratings_response, employees_response] = await Promise.all(
				[
					Grape.fetches.getJSON('/api/record/', ratings),
					Grape.fetches.getJSON('/api/record/', employee_count_query)
				]
			);

			return {
				records: ratings_response.records || [],
				total_active_employees: employees_response.records?.length || 0,
				filtered_by: this.selected_filter_by()
			};
		}
		catch (error)
		{
			console.error('Error fetching data:', error);
			return {
				records: [],
				total_active_employees: 0,
				filtered_by: this.selected_filter_by()
			};
		}
	}

	async update_chart_options()
	{
		try
		{
			let my_chart = echarts.init(document.getElementById('ratings-distribution-graph'));

			if (!my_chart)
			{
				console.error('Failed to initialize chart');
				return;
			}

			let filter_options = {
				performance_cycle_id: this.selected_cycle()?.performance_cycle_id,
				rating_method: this.selected_method()?.rating_method_name,
				employee_id: this.selected_employee()?.employee_id,
				company_id: this.selected_company()?.company_id,
				department_id: this.selected_department()?.department_id,
				manager_id: this.selected_manager()?.employee_id
			};

			let data = await this.fetch_ratings_distribution_data(filter_options);

			if (!data) 
				throw new Error('No data received from fetch_ratings_distribution_data');

			let processed_result = this.process_ratings_distribution(data, filter_options);

			if (!processed_result || !processed_result.data) 
				throw new Error('Failed to process ratings distribution data');

			let { data: processed_data, all_options } = processed_result;

			let total_employees = data.total_active_employees;

			if (this.selected_filter_by() === 'employee') 
				total_employees = 1; 

			else if (this.selected_filter_by() === 'department' && this.selected_department()) 
				total_employees = data.total_active_employees;

			else if (this.selected_filter_by() === 'manager' && this.selected_manager()) 
				total_employees = data.total_active_employees;

			let chart_container = document.getElementById('ratings-distribution-graph');

			if (!chart_container) 
				throw new Error('Chart container not found');

			chart_container.style.height = '600px';
			chart_container.style.width = '100%';
			my_chart.resize();

			if (!processed_data || processed_data.length === 0)
			{
				let method_display = this.selected_method()?.rating_method_name || 'All Methods';
				my_chart.clear();
				my_chart.setOption(
					{
						title: {
							text: 'No data available',
							subtext: `Rating Method: ${method_display}`,
							left: 'center',
							top: 'middle',
							textStyle: {
								fontSize: 18,
								fontWeight: 'normal'
							},
							subtextStyle: {
								fontSize: 14,
								color: '#666'
							}
						},
						grid: { show: false },
						xAxis: { show: false },
						yAxis: { show: false },
						series: []
					}
				);
				return;
			}

			let cycle_name = this.selected_cycle()?.cycle_name || 'Performance Ratings';
			let method_name = this.selected_method()?.rating_method_name || 'All Methods';

			let get_css_variable = (variable_name) => {
				return getComputedStyle(chart_container).getPropertyValue(variable_name).trim();
			}

			let combined_data = new Map();
			let bar_data = [];
			let percentage_data = [];

			all_options.forEach(option => {
				let total = 0;
				let cycle_data = {};
				let methods = new Set();
				let all_raters = [];

				processed_data.forEach(item => {
					let rating = item.ratings.find(r => `${r.option_symbol} - ${r.option_name}` === option);

					if (rating) {
						total += rating.count;
						cycle_data[item.cycle_name] = rating.count;
						methods.add(item.method_name);
						// Collect all raters for this rating option
						if (rating.raters) {
							all_raters.push(...rating.raters);
						}
					}
				});

				bar_data.push(total);
				let percentage = ((total / total_employees) * 100).toFixed(2);
				percentage_data.push(parseFloat(percentage));

				combined_data.set(option,
					{
						total,
						cycle_data,
						methods: Array.from(methods),
						raters: all_raters
					}
				);
			});

			let chart_options = {
				title: {
					text: `Rating Distribution - ${cycle_name}`,
					subtext: `Rating Method: ${method_name}`,
					left: 'center',
					top: 20,
					textStyle: {
						fontSize: 18
					},
					subtextStyle: {
						fontSize: 14
					}
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' },
					formatter: (params) => {
						let option = params[0].axisValue;
						let data = combined_data.get(option);
						let tooltip = `<strong>Rating: ${option}</strong><br/>`;
						tooltip += `Rating Method: ${data.methods.join(', ')}<br/>`;
						
						// Add breakdown by cycle
						Object.entries(data.cycle_data).forEach(([cycle, count]) => {
							if (count > 0) {
								tooltip += `Performance cycle: ${cycle}: ${count} employees<br/>`;
							}
						});
						
						tooltip += `<strong>Total: ${data.total} employees</strong><br/>`;
						
						if (this.show_percentage()) {
							let percentage = ((data.total / total_employees) * 100).toFixed(2);
							tooltip += `Percentage of employees: ${percentage}%<br/>`;
						}
						
						// Add rater information
						if (data.raters && data.raters.length > 0) {
							tooltip += '<br/><strong>Ratings given by:</strong><br/>';
							
							// Group by employee and manager
							let employee_ratings = data.raters.filter(r => !r.is_manager);
							let manager_ratings = data.raters.filter(r => r.is_manager);
							
							if (employee_ratings.length > 0) {
								tooltip += '<em>Self-ratings:</em><br/>';
								employee_ratings.forEach(rater => {
									tooltip += `• ${rater.employee_name} (Employee)<br/>`;
								});
							}
							
							if (manager_ratings.length > 0) {
								tooltip += '<em>Manager ratings:</em><br/>';
								manager_ratings.forEach(rater => {
									tooltip += `• ${rater.employee_name} (Manager) rated ${rater.plan_employee_name}<br/>`;
								});
							}
						}

						return tooltip;
					}
				},
				grid: {
					left: '3%',
					right: '3%',
					bottom: '15%',
					top: '15%',
					containLabel: true,
					show: true
				},
				xAxis: {
					show: true,
					type: 'category',
					name: 'Rating Options',
					nameLocation: 'middle',
					nameGap: 60,
					axisLabel: {
						interval: 0,
						rotate: 0,
						formatter: (value) => {
							let max_length = 15;
							let words = value.split(' ');
							let lines = [];
							let current_line = '';
							words.forEach(word => {
								if (current_line.length + word.length > max_length) {
									lines.push(current_line);
									current_line = word;
								}
								else
									current_line += (current_line.length ? ' ' : '') + word;
							});
							if (current_line)
								lines.push(current_line);
							
							return lines.join('\n');
						},
						fontSize: 12,
					},
					axisTick: {
						alignWithLabel: true,
						show: true
					},
					data: all_options,
				},
				yAxis: [
					{
						show: true,
						type: 'value',
						name: 'Number of Employees',
						nameLocation: 'middle',
						nameRotate: 90,
						nameGap: 50,
						min: 0,
						max: total_employees,
						interval: Math.max(1, Math.ceil(total_employees / 5)),
						axisLabel: {
							fontSize: 12,
							margin: 15
						},
					},
					{
						type: 'value',
						name: 'Percentage (%)',
						position: 'right',
						min: 0,
						max: 100,
						interval: 20,
						show: this.show_percentage()
					}
				],
				series: [
					{
						name: 'Total Employees',
						type: 'bar',
						barWidth: '60%',
						emphasis: {
							focus: 'series'
						},
						itemStyle: {
							color: get_css_variable('--fg-c2'),
							borderRadius: [5, 5, 0, 0]
						},
						data: all_options.map(option => combined_data.get(option).total)
					},
					...(this.show_percentage() ? [
						{
							name: 'Percentage',
							type: 'line',
							data: percentage_data,
							yAxisIndex: 1,
							itemStyle: { color: '#91CC75' },
							lineStyle: { width: 2 }
						}
					] : [])
				]
			};
			my_chart.setOption(chart_options, { notMerge: true });

			window.addEventListener('resize', () => {
				my_chart.resize();
			});
		}
		catch (error)
		{
			console.error('Error updating chart options:', error);
			let my_chart = echarts.init(document.getElementById('ratings-distribution-graph'));
			my_chart.setOption(
				{
					title:
					{
						text: 'Error loading chart data',
						subtext: 'Please try again or contact support if the problem persists',
						left: 'center',
						top: 'middle'
					}
				}
			);
		}
	}

	process_ratings_distribution(data, filter_options = {})
	{
		if (!data.records?.length) 
			return { data: [], rating_methods: [] };

		let ratings_by_cycle = new Map();
		let rated_employees = new Set();
		let total_active_employees = data.total_active_employees;

		let filters = (record, plan) => {

			let cycle_filter = !filter_options.performance_cycle_id || record.performance_cycle_id === filter_options.performance_cycle_id;

			let department_filter = !filter_options.department_id || record.department_id === filter_options.department_id;

			let company_filter = !filter_options.company_id || record.company_id === filter_options.company_id;

			let method_filter = !filter_options.rating_method || record.rating_method_name === filter_options.rating_method;

			let employee_filter = !filter_options.employee_id || plan.employee_id === filter_options.employee_id;

			let manager_filter = !filter_options.manager_id ||plan.manager_id === filter_options.manager_id;

			if (cycle_filter && department_filter && company_filter && method_filter && employee_filter && manager_filter) rated_employees.add(plan.employee_id);

			return cycle_filter && department_filter && company_filter && method_filter && employee_filter && manager_filter;
		};

		// Process records
		data.records.forEach(record => {
			record.linked_objective_plans?.forEach(plan => {
				if (!filters(record, plan)) return;

				let current_cycle_name = plan.performance_cycle_name || record.performance_cycle_name || 'Unknown performance cycle';
				let rating_method_key = record.rating_method_name || 'Unknown Method';

				if (!ratings_by_cycle.has(current_cycle_name)) 
					ratings_by_cycle.set(current_cycle_name, new Map());

				let cycle_methods = ratings_by_cycle.get(current_cycle_name);

				if (!cycle_methods.has(rating_method_key)) 
					cycle_methods.set(rating_method_key, new Map());

				let method_ratings = cycle_methods.get(rating_method_key);

				record.options?.forEach(option => {
					let option_key = `${option.option_symbol} - ${option.option_name}`;
					if (!method_ratings.has(option_key))
					{
						method_ratings.set(option_key,
							{
								option_symbol: option.option_symbol,
								option_name: option.option_name,
								count: 0,
								rating_method: rating_method_key,
								cycle_name: current_cycle_name,
								total_active_employees: total_active_employees,
								rated_employees: rated_employees.size,
								raters: [] // Track who gave this rating
							}
						);
					}
				});

				// Process manager ratings (where rater != plan employee)
				// Process manager ratings (where rater != plan employee)
				plan.manager_ratings?.forEach(rating => {
				    // Split comma-separated rating IDs and process each one
				    let rating_ids = rating.rating ? rating.rating.split(',').map(id => id.trim()) : [];
				
				    rating_ids.forEach(rating_id => {
				        // Find the matching option for this rating_id using option_id
				        let matching_option = record.options?.find(opt => opt.option_id == rating_id);
					
				        if (matching_option) {
				            let rating_key = `${matching_option.option_symbol} - ${matching_option.option_name}`;
						
				            if (method_ratings.has(rating_key)) {
				                let rating_data = method_ratings.get(rating_key);
				                rating_data.count++;
							
				                // Add manager rater information - with better fallback handling
				                let manager_name = rating.manager_name || 'Unknown Manager';
				                console.log('Manager name:', manager_name, 'Rating:', rating); // Debug line
							
				                rating_data.raters.push({
				                    employee_id: rating.manager_id,
				                    employee_name: manager_name,
				                    is_manager: true,
				                    plan_employee_id: plan.employee_id,
				                    plan_employee_name: plan.employee_name || 'Unknown'
				                });
				            }
				        }
				    });
				});

				// Process employee self-ratings (where rater = plan employee)
				plan.employee_ratings?.forEach(rating => {
					// Split comma-separated rating IDs and process each one
					let rating_ids = rating.rating ? rating.rating.split(',').map(id => id.trim()) : [];
					
					rating_ids.forEach(rating_id => {
						// Find the matching option for this rating_id using option_id
						let matching_option = record.options?.find(opt => opt.option_id == rating_id);
						
						if (matching_option) {
							let rating_key = `${matching_option.option_symbol} - ${matching_option.option_name}`;
							
							if (method_ratings.has(rating_key)) {
								let rating_data = method_ratings.get(rating_key);
								rating_data.count++;
								
								// Add employee self-rater information
								rating_data.raters.push({
									employee_id: plan.employee_id,
									employee_name: plan.employee_name || 'Unknown',
									is_manager: false,
									plan_employee_id: plan.employee_id,
									plan_employee_name: plan.employee_name || 'Unknown'
								});
							}
						}
					});
				});
			});
		});

		let processed_data = [];
		let all_options = new Set();

		for (let [cycle_name, methods] of ratings_by_cycle)
		{
			for (let [method_name, ratings] of methods)
			{
				let ratings_array = Array.from(ratings.values());
				processed_data.push(
					{
						cycle_name,
						method_name,
						ratings: ratings_array,
						total_active_employees: total_active_employees,
						rated_employees: rated_employees.size
					}
				);

				ratings_array.forEach(rating => {
					all_options.add(`${rating.option_symbol} - ${rating.option_name}`);
				});
			}
		}

		return {
			data: processed_data,
			all_options: Array.from(all_options)
		};
	}

	show_report_help()
	{
		Grape.dialog.open('RatingsDistributionHelp', { employee_id: this.page.bindings.id });
	}
}

class ReportRatingsDistributionPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportRatingsDistributionViewModel(this);
	}

	async init()
	{
		document.title = tr('Performance Ratings Distribution Report');
		window.current_page_title(tr('Performance Ratings Distribution Report'));
		await this.updateData();
	}

	async updateData()
	{
		//fetch performance_cycles
		let performance_cycles = {
			table: 'performance_cycle',
			schema: 'perfm_manage',
			limit: 1000   
		}

		let rating_methods = {
			table: 'rating_system',
			schema: 'perfm_manage',
			limit: 1000
		}

		let [performance_response, method_response] = await Promise.all(
			[
				Grape.fetches.getJSON('/api/record/', performance_cycles),
				Grape.fetches.getJSON('/api/record/', rating_methods)
			]
		);

		this.viewModel.performance_cycles(performance_response.records);
		this.viewModel.rating_methods(method_response.records);

		if (this.viewModel.selected_filter_by() == 'employee')
		{
			if (this.viewModel.selected_employee())
			{
				this.viewModel.selected_department(null);
				this.viewModel.selected_company(null);
				this.viewModel.show_percentage(false)
				this.viewModel.selected_manager(null)
				await this.viewModel.init_chart();
			}
		}
		else if (this.viewModel.selected_filter_by() == 'department')
		{
			if (this.viewModel.selected_department())
			{
				this.viewModel.selected_employee(null);
				this.viewModel.selected_company(null);
				this.viewModel.selected_manager(null);
				await this.viewModel.init_chart();
			}
		}
		else if (this.viewModel.selected_filter_by() == 'company')
		{
			if (this.viewModel.selected_company())
			{
				this.viewModel.selected_employee(null);
				this.viewModel.selected_department(null);
				this.viewModel.selected_manager(null);
				await this.viewModel.init_chart();
			}
		}
		else if (this.viewModel.selected_filter_by() == 'manager')
		{
			this.viewModel.selected_company(null);
			this.viewModel.selected_department(null);
			this.viewModel.selected_employee(null);
			this.viewModel.show_percentage(false);
			await this.viewModel.init_chart();
		}
	}
}

export default {
	route: '[/]report/performance_management/ratings_distribution_report',
	page_class: ReportRatingsDistributionPage,
	template: template,
	template_filename: 'translation/ratings_distribution_report'
};
